import { AuthLayout } from '@/components/layout/AuthLayout';
import { useNavigate } from 'react-router-dom';

/**
 * ResetPasswordPage Route Component
 * Handles the password reset flow when a user clicks the link from their email.
 * Renders the AuthLayout in 'forgot' mode.
 */
export function ResetPasswordPage() {
  const navigate = useNavigate();

  // If user switches to login/register from this page, navigate to main login route
  const handleSwitch = () => {
    navigate('/login');
  };

  return (
    <AuthLayout
      authType='forgot'
      onSwitch={handleSwitch}
      submitLabel='RESET PASSWORD'
      dividerText='or sign in with'
      formId='reset-password-form'
    >
      {/* Children are handled internally by AuthLayout for 'forgot' type */}
      {null}
    </AuthLayout>
  );
}

export default ResetPasswordPage;
